import {
  LedgerErrorCode,
  LedgerItemErrorCode,
  LedgerItemUserError,
  LedgerUserError,
} from 'lib/graphql/storeadmin'

// Common error handle function for Ledger
export const ledgerErrorHandler = (error: LedgerUserError[]): string[] => {
  const errorMessages = []
  error.forEach((value: LedgerUserError) => {
    switch (value.code) {
      case LedgerErrorCode.Invalid:
        errorMessages.push('適切な値を入力してください。')
        break
      case LedgerErrorCode.NotFound:
        errorMessages.push('対象を見つけることができません。')
        break
      case LedgerErrorCode.TooLong:
        errorMessages.push(
          '入力値が短すぎたり長すぎたりしないことを確認してください。'
        )
        break
      case LedgerErrorCode.TooShort:
        errorMessages.push(
          '入力値が短すぎたり長すぎたりしないことを確認してください。'
        )
        break
      case LedgerErrorCode.AlreadyRegistered:
        errorMessages.push('選択された予約は既に支払いが完了しています。')
        break
      case LedgerErrorCode.NotApproved:
        errorMessages.push(
          '選択された予約は承認されていません。予約を承認してから支払い情報を登録してください。'
        )
        break
      default:
        errorMessages.push('エラーが発生しました。')
    }
  })
  return errorMessages
}

export const ledgerItemErrorHandler = (
  error: LedgerItemUserError[]
): string[] => {
  const errorMessages = []
  error.forEach((value) => {
    switch (value.code) {
      case LedgerItemErrorCode.Invalid:
        errorMessages.push('適切な値を入力してください。')
        break
      case LedgerItemErrorCode.NotFound:
        errorMessages.push('対象を見つけることができません。')
        break
      case LedgerItemErrorCode.TooLong:
        errorMessages.push(
          '入力値が短すぎたり長すぎたりしないことを確認してください。'
        )
        break
      case LedgerItemErrorCode.TooShort:
        errorMessages.push(
          '入力値が短すぎたり長すぎたりしないことを確認してください。'
        )
        break
      default:
        errorMessages.push('エラーが発生しました。')
    }
  })
  return errorMessages
}
